import { IncomingMessage } from 'http';

import { readAppCookiesServerApp } from '../Cookie/readAppCookiesServerApp';

import { ApiClient } from './ApiClient';

export function getApiClientPageLoader(req: IncomingMessage): ApiClient {
  const apiClient = new ApiClient();
  const appCookies = readAppCookiesServerApp(req);
  apiClient.withCookies(appCookies);
  return apiClient;
}
